import React, { Fragment, useContext } from 'react';
import styled from 'styled-components';
import ToggleButtonInput from '../../connectedForm/ToggleButtonInput/ToggleButtonInput';
import getIn from '../../connectedForm/utils/getIn';
import { useDispatch } from 'react-redux';
import ExpansionContext from '../../Context/ExpansionContext';

const DropdownToggle = styled.div`
  position: absolute;
  right: 5px;
  top: 2px;
`;

const ExpansionFormatter = ({ value, ...props }) => {
  const rowUuid: string = props.dependentValues?.rowData?.uuid;
  const Formatter = getIn(props, 'dependentValues.options.formatter');
  const displayKey = getIn(props, 'dependentValues.options.displayKey');

  const { openMap, setOpenMap } = useContext(ExpansionContext);
  const expanded: boolean = openMap[rowUuid];

  const dispatch = useDispatch();
  return (
    <Fragment>
      <Formatter {...props} value={value.length && value.length > 0 ? value[0][displayKey] : value[displayKey]} />
      <DropdownToggle>
        <ToggleButtonInput
          value={!expanded}
          onChange={() => {
            setOpenMap((currentOpenMap) => ({
              ...currentOpenMap,
              [rowUuid]: !currentOpenMap[rowUuid],
            }));
          }}
          checkedLabel={'Expand'}
          uncheckedLabel={'Hide'}
        />
      </DropdownToggle>
    </Fragment>
  );
};

export default ExpansionFormatter;
